import type { StripeCustomerData } from '../../repositories';

type SubscriptionData = NonNullable<StripeCustomerData['subscription']>;

export class StripeSubscription {
  constructor(private readonly values: SubscriptionData) {}

  public toJson() {
    return this.values;
  }

  public getInterval(): [number, 'month'] {
    return [this.values.intervalCount, this.values.interval];
  }
}
